









































import Vue from 'vue'
import AccountButtons from '@/components/user/AccountButtons.vue'

export default Vue.extend({
  name: 'AppBar',
  components: {
    AccountButtons,
  },
  props: {
    mainNavigation: {
      type: Array,
    },
  },
  computed: {
    showMenu: function (): boolean {
      if (this.$vuetify.breakpoint.mdAndDown) {
        return false
      }

      return true
    },
  },
  data: () => ({
    topAppBar: true,
  }),
})
